<template>
    <app-content-admin>
        <template slot="header">AdZone</template>
        <template>
            <v-row align="center">
                <v-col cols="10">
                    <v-text-field
                        v-model="searchTerm"
                        label="Zone Name"
                        outlined
                        clearable
                        solo-inverted
                        full-width
                    ></v-text-field>
                </v-col>
                <v-col cols="2">
                    <v-btn @click="zoneListData" class="ma-2">Search</v-btn>
                </v-col>
            </v-row>
        </template>
   
        <template slot="button">
            <v-btn
                style="margin-left: auto"
                large
                color="primary"
                to="/adzone/add_adzone"
            >
                + Add AdZone
            </v-btn>
        </template>

        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="p-3">
                    <table class="table table-fluid no-wrap">
                        <thead>
                            <th scope="col">Id</th>
                            <th scope="col">Name</th>
                            <th scope="col">Description</th>
                            <th scope="col">Rotate time(seconds)</th>
                            <th scope="col">Active</th>
                            <th scope="col">Action</th>
                        </thead>
                        <tbody>
                            <tr
                                class="text-center"
                                v-for="(adzone, i) in displayedItems"
                                :key="i"
                            >
                                <td :data-label="$t('Id')">
                                    {{ adzone.zone_id }}
                                </td>
                                <td
                                    :data-label="$t('Name')"
                                    class="text-truncate"
                                >
                                    {{ adzone.zone_name }}
                                </td>
                                <td
                                    :data-label="$t('Description')"
                                    class="text-truncate"
                                >
                                    {{ adzone.zone_description }}
                                </td>
                                <td :data-label="$t('Rotate Time')">
                                    {{ adzone.zone_rotate_time }}
                                </td>
                                <td :data-label="$t('Active')">
                                    <v-switch
                                        v-model="adzone.zone_active"
                                        :disabled="true"
                                    ></v-switch>
                                </td>
                                <td :data-label="$t('action')">
                                    <v-menu
                                        :close-on-content-click="true"
                                        :nudge-width="200"
                                        :open-on-click="true"
                                        offset-y
                                        offset-x
                                        left
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-btn
                                                color="primary"
                                                text
                                                small
                                                icon
                                                v-on="on"
                                            >
                                                <v-icon>more_horiz</v-icon>
                                            </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item
                                                @click="
                                                    ViewAdZoneDetail(
                                                        adzone.zone_id
                                                    )
                                                "
                                            >
                                                <v-list-item-action>
                                                    Edit
                                                </v-list-item-action>
                                            </v-list-item>

                                            <v-list-item
                                                @click="
                                                    selectAdZoneToDelete(
                                                        adzone.zone_id
                                                    )
                                                "
                                                v-if="isRole == 'admin'"
                                            >
                                                <v-list-item-action>
                                                    Delete
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- Confirmation Dialog -->
                    <v-dialog v-model="showConfirmationDialog" max-width="400">
                        <v-card>
                            <v-card-title>Confirm Deletion</v-card-title>
                            <v-card-text>
                                Are you sure you want to delete this zone?
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                    color="primary"
                                    @click="deleteZone(adzoneToDelete)"
                                >
                                    Yes
                                </v-btn>
                                <v-btn @click="cancelDelete">No</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card>
                <v-pagination
                    class="pagination mb-2"
                    v-model="currentPage"
                    :length="totalPages"
                    @input="updatePage"
                    :total-visible="7"
                ></v-pagination>
            </v-flex>
        </v-layout>
    </app-content-admin>
</template>

<script>
import vForm from "@/mixins/vForm";
import ActiveLabel from "../../components/status/ActiveLabel.vue";
import store from "@/store";

export default {
    mixins: [vForm],

    data() {
        return {
            adzones: [],
            form: {
                page: 1,
                offset: 10,
            },
            itemsPerPage: 10,
            currentPage: 1,

            showDialog: false,
            showConfirmationDialog: false, // Initialize to false
            adzoneToDelete: null, // Store the selected user for deletion
            zoneRotateTime: 0,
            isRole: null,
            searchTerm: "",
            searchResult: [],
        };
    },

    components: { ActiveLabel },

    computed: {
        totalPages() {
            return Math.ceil(this.adzones.length / this.itemsPerPage);
        },
        displayedItems() {
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            const endIndex = startIndex + this.itemsPerPage;
            console.log(endIndex);
            return this.adzones.slice(startIndex, endIndex);
        },
    },

    created() {
        this.zoneListData();
        this.isRole = this.$store.getters["auth/role"];
    },

    methods: {
        //Pagination
        updatePage(page) {
            this.currentPage = page;
        },

        onListChange(page) {
            this.zoneListData(10, page);
        },

        //Read all zone data
        zoneListData() {
            let loader = this.$loading.show();

            axios
                .get(`/api/auth/get_ad_zone_list`,{
                    params: {
                        search_term: this.searchTerm
                    }})
                .then((res) => res.data)
                .then((res) => {
                    this.adzones = res.data.result;
                    console.log(this.adzones);
                  
                })
                .catch((e) => {
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    loader.hide();
                });
        },

        //Delete Specific zone data
        async deleteZone(id) {
            let loader = this.$loading.show();

            try {
                let res = await axios.post(`/api/auth/delete_ad_zone`, {
                    zone_id: id,
                });

                // Log the response for debugging
                console.log("Delete Adzone API Response:", res);

                if (res.data) {
                    this.$toastr.s("Delete successfully");
                    this.cancelDelete();
                    this.$router.push({ path: "/adzone" });
                }
            } catch (e) {
                console.error("Error deleting adzone:", e);

                this.$toastr.e(e.message);
            } finally {
                loader.hide();
                this.zoneListData();
            }
        },

        //Edit Zone route
        ViewAdZoneDetail(id) {
            this.$router.push({ path: "/adzone/view_adzone/" + id });
        },

        //Delete zone dialog function
        selectAdZoneToDelete(id) {
            // Store the user data to delete
            this.adzoneToDelete = id;

            // Open the confirmation dialog
            this.showConfirmationDialog = true;
        },
        cancelDelete() {
            // Reset the data and close the confirmation dialog
            this.showConfirmationDialog = false;
            this.adzoneToDelete = null;
        },

    

        handleSearch() {
            // Show loader
            let loader = this.$loading.show();
            console.log("Search Target", this.searchTerm);

            // Trigger API call with the search term
            axios
            .get(`/api/auth/search_ad_zone_list`, {
                    params: {
                        search_term: this.searchTerm,
                    },
                }          
                )
                .then((res) => res.data)
                .then((res) => {
                    this.adzones = res.data.result; // Update adzones with searchResult
                console.log("Adzones after search:", this.adzones);

                })
                .catch((e) => {
                    console.error("Error filter adzone:", e);
                    this.$toastr.e(e.message);
                })
                .finally(() => {
                    // Hide loader
                    loader.hide();
                });



             
        },

    },
};
</script>
